var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"section-wrapper"},[_c('div',{staticClass:"section-title"},[_vm._v(" 五."+_vm._s(_vm.entityJson.name)+" ")]),_c('TaxBasis',{attrs:{"data":_vm.entityJson.data.taxModelResult,"text":_vm.entityJson.text,"name":"纳税基本情况"}}),_c('TaxRiskEvaluate',{attrs:{"data":_vm.entityJson.data.pdfCatalogsList}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }